
export default {
  data() {
    return {
      persyaratan: [
        { label: "Tidak Sesuai", value: "Tidak Sesuai", color: "red" },
        { label: "Kurang Sesuai", value: "Kurang Sesuai", color: "yellow" },
        { label: "Sesuai", value: "Sesuai", color: "green" },
        { label: "Sangat Sesuai", value: "Sangat Sesuai" },
      ],
      prosedur: [
        { label: "Tidak Mudah", value: "Tidak Mudah", color: "red" },
        { label: "Kurang Mudah", value: "Kurang Mudah", color: "yellow" },
        { label: "Mudah", value: "Mudah", color: "green" },
        { label: "Sangat Mudah", value: "Sangat Mudah" },
      ],
      pelayanan: [
        { label: "Tidak Cepat", value: "Tidak Cepat", color: "red" },
        { label: "Kurang Cepat", value: "Kurang Cepat", color: "yellow" },
        { label: "Cepat", value: "Cepat", color: "green" },
        { label: "Sangat Cepat", value: "Sangat Cepat" },
      ],
      tarif: [
        { label: "Sangat Mahal", value: "Sangat Mahal", color: "red" },
        { label: "Cukup Mahal", value: "Cukup Mahal", color: "yellow" },
        { label: "Murah", value: "Murah", color: "green" },
        { label: "Gratis", value: "Gratis" },
      ],
      ketentuan: [
        { label: "Tidak Sesuai", value: "Tidak Sesuai", color: "red" },
        { label: "Kurang Sesuai", value: "Kurang Sesuai", color: "yellow" },
        { label: "Sesuai", value: "Sesuai", color: "green" },
        { label: "Sangat Sesuai", value: "Sangat Sesuai" },
      ],
      kompetensi: [
        { label: "Tidak Kompeten", value: "Tidak Kompeten", color: "red" },
        { label: "Kurang Kompeten", value: "Kurang Kompeten", color: "yellow" },
        { label: "Kompeten", value: "Kompeten", color: "green" },
        { label: "Sangat Kompeten", value: "Sangat Kompeten" },
      ],
      sikap: [
        { label: "Tidak Sopan dan Ramah", value: "Tidak Sopan dan Ramah", color: "red" },
        {
          label: "Kurang Sopan dan Ramah",
          value: "Kurang Sopan dan Ramah",
          color: "yellow",
        },
        { label: "Sopan dan Ramah", value: "Sopan dan Ramah", color: "green" },
        { label: "Sangat Sopan dan Ramah", value: "Sangat Sopan dan Ramah" },
      ],
      maklumat: [
        { label: "Buruk", value: "Buruk", color: "red" },
        { label: "Cukup", value: "Cukup", color: "yellow" },
        { label: "Baik", value: "Baik", color: "green" },
        { label: "Sangat Baik", value: "Sangat Baik" },
      ],
      pengaduan: [
        { label: "Tidak Ada", value: "Tidak Ada", color: "red" },
        {
          label: "Ada Tapi Tidak Berfungsi",
          value: "Ada Tapi Tidak Berfungsi",
          color: "yellow",
        },
        {
          label: "Berfungsi Kurang Maksimal",
          value: "Berfungsi Kurang Maksimal",
          color: "green",
        },
        { label: "Dikelola Dengan Baik", value: "Dikelola Dengan Baik" },
      ],

      form: {
        id: "",
        nama: "",
        alamat: "",
        hp: "",
        email: "",
        nik: "",
        ktp: null,
        status: "",
        keterangan: "",
        rekomendasi: null,
        nomorP: "",
        tanggalP: "",
        namaP: "",
        jabatanP: "",
        suratP: null,
        statusP: "",
        nomorR: "",
        tanggalR: "",
        namaR: "",
        jabatanR: "",
        suratR: null,
        statusR: "",
        judul: "",
        lokasi: "",
        tujuan: "",
        lingkup: "",
        tgl_mulai: "",
        tgl_selesai: "",
        proposal: null,
        kategori_id: "",
        statusPro: "",
        survey: "",
        laporan: "",
        userId: "",
        createAt: "",
        editedAt: "",
        createBy: "",
        ktp_old: null,
        rekomendasi_old: null,
        suratP_old: null,
        suratR_old: null,
        proposal_old: null,
        laporan_old: null,
        kategori_uraian: "",
      },

      ikm: {
        id: "",
        nama: "",
        umur: "",
        email: "",
        umur: "",
        pendidikan: "",
        pekerjaan: "",
        persyaratan: "",
        prosedur: "",
        pelayanan: "",
        tarif: "",
        ketentuan: "",
        kompetensi: "",
        sikap: "",
        maklumat: "",
        pengaduan: "",
        createAt: "",
      },

      list_data: [],
      list_kategori: [],
      file_path: this.$store.state.url.URL_APP + "uploads/",

      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data: true,

      currentDate: "",
      currentDateWithFormat: "",

      mdl_add: false,
      mdl_pengantar: false,
      mdl_rekomendasi: false,
      mdl_penelitian: false,
      mdl_laporan: false,
      mdl1: false,
      mdl2: false,
      mdll: false,
      mdl3: false,
      mdl_open: false,
      mdl_rek: false,
      mdl_edit: false,
      mdl_hapus: false,
      mdl_lihatP: false,
      mdl_lihatR: false,
      mdl_lihatPro: false,
      btn_add: false,
    };
  },
  methods: {
    getView: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Penelitian + "view", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({
          userId: this.userId,
          data_ke: this.page_first,
          cari_value: this.cari_value,
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          this.list_data = res_data.data;
          this.page_last = res_data.jml_data;
          this.$store.commit("hideLoading");
          console.log('====================================');
          console.log(res_data);
          console.log('====================================');
        });
    },

    addIkm: function (id_penelitian) {
      console.log(id_penelitian);
      console.log(this.ikm);
      fetch(this.$store.state.url.URL_IKMM + "addData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(this.ikm),
      }).then((res_data) => {
        console.log(res_data);
        this.addSurvey(id_penelitian);
        this.mdl2 = false;
        this.Notify("Sukses Mengisi Survey", "primary", "check_circle_outline");
      });
    },
    addSurvey: function (idid) {
      console.log(idid);
      fetch(this.$store.state.url.URL_Penelitian + "addSurvey", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({ ididid: idid }),
      }).then((res_data) => {
        console.log(res_data);
        this.getView();
        this.mdll = true;
      });
    },

    getKategori: function () {
      fetch(this.$store.state.url.URL_Penelitian + "getKategori", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          // console.log('telasooooo')
          this.list_kategori = res_data;
          console.log(this.list_kategori);
        });
    },

    addData: function () {
      var formData = new FormData();
      formData.append("data", JSON.stringify(this.form));
      // formData.append('data', JSON.stringify(this.form))
      formData.append("file", this.form.ktp);

      // console.log(formData);

      fetch(this.$store.state.url.URL_Penelitian + "addData", {
        method: "POST",
        headers: {
          // "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: formData,
      }).then((res_data) => {
        this.Notify("Sukses Menambah Data", "primary", "check_circle_outline");
        console.log(res_data);
        this.getView();
      });
    },

    addPengantar: function () {
      var formData = new FormData();
      formData.append("data", JSON.stringify(this.form));
      formData.append("file", this.form.suratPeng);

      console.log(formData);

      fetch(this.$store.state.url.URL_Penelitian + "addPengantar", {
        method: "POST",
        headers: {
          // "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: formData,
      }).then((res_data) => {
        this.Notify("Sukses Menambah Surat Pengantar", "primary", "check_circle_outline");
        console.log(res_data);
        this.getView();
      });
    },

    addRekomendasi: function () {
      var formData = new FormData();
      formData.append("data", JSON.stringify(this.form));
      formData.append("file", this.form.suratRek);

      console.log(formData);

      fetch(this.$store.state.url.URL_Penelitian + "addRekomendasi", {
        method: "POST",
        headers: {
          // "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: formData,
      }).then((res_data) => {
        this.Notify(
          "Sukses Menambah Surat Rekomendasi",
          "primary",
          "check_circle_outline"
        );
        console.log(res_data);
        this.getView();
      });
    },

    addPenelitian: function () {
      var formData = new FormData();
      formData.append("data", JSON.stringify(this.form));
      formData.append("file", this.form.filePro);

      console.log(formData);

      fetch(this.$store.state.url.URL_Penelitian + "addPenelitian", {
        method: "POST",
        headers: {
          // "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: formData,
      }).then((res_data) => {
        this.Notify("Sukses Menambah Data Penelitian", "primary", "check_circle_outline");
        console.log(res_data);
        this.getView();
      });
    },

    editData: function () {
      var formData = new FormData();
      formData.append("data", JSON.stringify(this.form));
      formData.append("file", this.form.ktp_old);
      fetch(this.$store.state.url.URL_Penelitian + "editData", {
        method: "POST",
        headers: {
          // "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: formData,
      }).then((res_data) => {
        this.Notify("Sukses Merubah Data", "warning", "check_circle_outline");
        this.getView();
      });
    },

    removeData: function (a, b, c, d, e, f, g) {
      // console.log(a);
      // console.log(b);
      fetch(this.$store.state.url.URL_Penelitian + "removeData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({
          id: a,
          ktp: b,
          suratP: c,
          suratR: d,
          proposal: e,
          rekomendasi: f,
          laporan: g,
        }),
      }).then((res_data) => {
        this.Notify("Sukses Menghapus Data", "negative", "check_circle_outline");
        this.getView();
      });
    },
    selectData: function (data) {
      this.form.id = data.id;
      this.form.nama = data.nama;
      this.form.alamat = data.alamat;
      this.form.hp = data.hp;
      this.form.email = data.email;
      this.form.nik = data.nik;
      this.form.ktp = data.ktp;
      this.form.status = data.status;
      this.form.keterangan = data.keterangan;
      this.form.rekomendasi = data.rekomendasi;
      this.form.nomorP = data.nomorP;
      this.form.tanggalP = data.tanggalP;
      this.form.namaP = data.namaP;
      this.form.jabatanP = data.jabatanP;
      this.form.suratP = data.suratP;
      this.form.statusP = data.statusP;
      this.form.nomorR = data.nomorR;
      this.form.tanggalR = data.tanggalR;
      this.form.namaR = data.namaR;
      this.form.jabatanR = data.jabatanR;
      this.form.suratR = data.suratR;
      this.form.statusR = data.statusR;
      this.form.judul = data.judul;
      this.form.lokasi = data.lokasi;
      this.form.tujuan = data.tujuan;
      this.form.lingkup = data.lingkup;
      this.form.tgl_mulai = data.tgl_mulai;
      this.form.tgl_selesai = data.tgl_selesai;
      this.form.proposal = data.proposal;
      this.form.kategori_id = data.kategori_id;
      this.form.statusPro = data.statusPro;
      this.form.survey = data.survey;
      this.form.userId = data.userId;
      this.form.createBy = data.createBy;
      this.form.createAt = data.createAt;
      this.form.kategori_uraian = data.kategori_uraian;
      this.form.laporan = data.laporan;
      // this.form.rekomendasi_old =  data.rekomendasi
      // this.form.ktp_old =  data.ktp
    },

    editLaporan: function () {
      var formData = new FormData();
      formData.append("data", JSON.stringify(this.form));
      formData.append("file", this.form.laporan);

      fetch(this.$store.state.url.URL_Penelitian + "editLaporan", {
        method: "POST",
        headers: {
          authorization: "kikensbatara " + localStorage.token,
        },
        body: formData,
      }).then((res_data) => {
        this.Notify("Sukses Mengunggah Laporan Akhir", "primary", "check_circle_outline");
        console.log(this.file_old);
        this.getView();
      });
    },

    // ====================================== PAGINATE ====================================
    Notify: function (message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: "top",
        timeout: 500,
      });
    },
    btn_prev: function () {
      this.cek_load_data = true;
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function () {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function () {
      this.page_first = 1;
      this.getView();
    },

    date: function () {
      var currentDate = new Date();
      console.log(currentDate);

      var currentDateWithFormat = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
      console.log(currentDateWithFormat);
    },

    convert_tgl: function (dateString) {
      var date = new Date(dateString);
      var getBulan = date.getMonth() + 1;
      var bulan = "";
      if (getBulan == "1") {
        bulan = "Januari";
      } else if (getBulan == "2") {
        bulan = "Februari";
      } else if (getBulan == "3") {
        bulan = "Maret";
      } else if (getBulan == "4") {
        bulan = "April";
      } else if (getBulan == "5") {
        bulan = "Mei";
      } else if (getBulan == "6") {
        bulan = "Juni";
      } else if (getBulan == "7") {
        bulan = "Juli";
      } else if (getBulan == "8") {
        bulan = "Agustus";
      } else if (getBulan == "9") {
        bulan = "September";
      } else if (getBulan == "10") {
        bulan = "Oktober";
      } else if (getBulan == "11") {
        bulan = "November";
      } else if (getBulan == "12") {
        bulan = "Desember";
      }

      return date.getDate() + " " + bulan + " " + date.getFullYear();
      // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
    },

    // ====================================== PAGINATE ====================================
  },

  mounted() {
    var get_profile = JSON.parse(localStorage.profile);
    this.form.userId = get_profile.profile.userId;
    this.form.email = get_profile.profile.email;
    this.form.hp = get_profile.profile.hp;
    this.form.nama = get_profile.profile.nama;
    this.ikm.nama = get_profile.profile.nama;
    this.ikm.email = get_profile.profile.email;
    this.getKategori();
    this.getView();
    this.date();
  },
};
